import React from 'react';
import { Link } from 'react-router-dom';

export const RecruiterCards = ({items}) => {
    return (
        <div className='flex flex-wrap justify-center items-center sm:flex-col'>
            {items && items.map(item => {
                return(
                    <div className="card w-3/12	bg-base-100 shadow-xl border-2 border-sky-500 m-10 sm:w-4/5 md:w-4/12 lg:2/12 2xl:w-2/12 p-10" key={item.id}>
                        <figure className='containerImage'><img src={item.img} alt={`imagen ${item.name}`} className='h-full'/></figure>
                        <div className="card-body">
                            <h2 className="card-title">
                                {item.name}
                            </h2>
                            <p className='texto h-32 xl:h-24'>Ingresa al link para conocer más sobre {item.data}</p>
                            <div className="card-actions justify-end">
                                <Link to={`/recruiter/${item.category}`} className="btn btn-primary">Ver más</Link>
                            </div>
                        </div>
                    </div>
            )
            })}
        </div>
    )
}
